import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ssnmask',
     
})
export class SsnMaskPipe implements PipeTransform {
  transform(value: string, showMask: boolean): string {
    if (value) {
      if (!showMask || (value.length < 9 && value.length !== 4)) {
        return value;
      }
      return '***-**-' + value.substr(value.length - 4, value.length);
    } else {
      return value;
    }
  }
}
